import React, { FunctionComponent, memo } from 'react';
import { InputField } from 'plume-ui';
import {
  SupportOutreachTriggerFormFields,
  SupportTriggerRendererProps,
} from '../../../../../types';
import { FormikSupportOutreachTriggerValue } from '../support/types';
import useFormControls from '../../../hooks/useFormControls';
import FormattedMessage from '../../../../../../../utils/components/FormattedMessage';
import OutreachConfigFieldMessages from '../../../../../../Outreach/components/OutreachConfigFieldMessages';
import { OutreachTypes } from '../../../../../../../urls';

type DropdownProperties = 'scheduleMaxFrequencyOfSupportOutreachUnit';
type MaxFrequencyFieldsProps = Pick<
  SupportTriggerRendererProps<
    FormikSupportOutreachTriggerValue,
    DropdownProperties
  >,
  'form' | 'field'
> & { renderDropdownFor: CallableFunction; outreachType?: OutreachTypes };

const mapOutreachTypeToFrequencyFieldLabelId: Record<OutreachTypes, string> = {
  [OutreachTypes.Email]:
    'outreach.form.supportOutreachTriggerSection.maxFrequencyOfSupportOutreach',
  [OutreachTypes.Webhooks]: '',
  [OutreachTypes.Push]:
    'outreach.form.supportOutreachTriggerSection.maxFrequencyOfSubscriberOutreach',
};

const MaxFrequencyFields: FunctionComponent<MaxFrequencyFieldsProps> = ({
  field,
  form,
  renderDropdownFor,
  outreachType = OutreachTypes.Email,
}) => {
  const { setPropertyValue } = useFormControls<
    FormikSupportOutreachTriggerValue
  >(field, form);
  if (outreachType === OutreachTypes.Webhooks) return <></>;
  const labelId = mapOutreachTypeToFrequencyFieldLabelId[outreachType];
  return (
    <>
      <div className="OutreachContainer__subscriber-outreach-trigger-label">
        <span className="color-required">* </span>
        <FormattedMessage id={labelId} />
      </div>
      <div className="OutreachContainer__subscriber-outreach-trigger-field OutreachContainer__subscriber-outreach-trigger-field--schedule">
        <div className="OutreachContainer__subscriber-outreach-trigger-field-wrapper">
          <InputField
            name={
              SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreach
            }
            type="number"
            min={1}
            value={
              field.value[
                SupportOutreachTriggerFormFields
                  .ScheduleMaxFrequencyOfSupportOutreach
              ]
            }
            classes={(current) => ({
              ...current,
              root: `${current.root} m-r-s m-l-0`,
            })}
            onInput={(e) =>
              setPropertyValue(
                SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreach,
                parseFloat(e.currentTarget.value),
              )
            }
          />
          <FormattedMessage id="outreach.form.supportOutreachTriggerSection.every" />
          <InputField
            name={
              SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachEvery
            }
            type="number"
            min={1}
            value={
              field.value[
                SupportOutreachTriggerFormFields
                  .ScheduleMaxFrequencyOfSupportOutreachEvery
              ]
            }
            onInput={(e) =>
              setPropertyValue(
                SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachEvery,
                parseFloat(e.currentTarget.value),
              )
            }
          />
          {renderDropdownFor(
            SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachUnit,
          )}
        </div>
        <OutreachConfigFieldMessages
          propertyName={
            SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreach
          }
          field={field}
          form={form}
        />
        <OutreachConfigFieldMessages
          propertyName={
            SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachEvery
          }
          field={field}
          form={form}
        />
      </div>
    </>
  );
};

export default memo(MaxFrequencyFields);
